<!--
 * @Author: wsx
 * @Date: 2022-01-05 18:45:47
 * @LastEditTime: 2022-01-12 18:03:34
 * @LastEditors: your name
 * @Description:地图摄像头icon点击展示
-->
<template>
  <div class="mapVideo">
    <div :class="['pointMenuList', { hideShow: !showMenu }]">
      <div
        class="pointMenuItem"
        v-for="item in menuList"
        :style="{ transform: `translate(${item.left}px, ${item.top}px)` }"
        :key="item.id"
        @click="clickMenu(item)"
      >
        {{ item.name }}
      </div>
    </div>
    <h-video-dialog
      v-if="videoDialogData && showVideoDialog"
      v-model:visible="showVideoDialog"
      :videoData="videoDialogData"
      :title="videoTitle"
    ></h-video-dialog>
  </div>
</template>
<script >
import {
  defineComponent,
  onMounted,
  reactive,
  toRefs,
  watch,
  watchEffect,
} from "vue";
import { _count } from "@/utils/index.js";
export default defineComponent({
  name: "mapVideo",
  components: {},
  props: {
    videoStatus: {
      type: Boolean,
      default: false,
    },
    mapVideoData: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    const data = reactive({
      drawOption: {
        positioning: "bottom-center",
        offset: [0, -20],
        stopEvent: false,
      },
      menuList: [
        { id: 1, name: "相机信息", left: 0, top: -70 },
        { id: 2, name: "实时视频", left: 0, top: 0 },
        { id: 3, name: "视频回放", left: 0, top: 0 },
        // { id: 4, name: "编辑", left: 0, top: 0 },
        // { id: 5, name: "查看", left: 0, top: 0 },
      ],
      r: 70,
      showMenu: false,
      time: null,
      showVideoDialog: false,
      videoDialogData: null,
      videoTitle: "",
    });
    const refData = toRefs(data);
    data.menuList = _count(data.menuList, data.r);
    watchEffect(() => {
      data.videoDialogData = props.mapVideoData;
    });
    // 点击菜单
    const clickMenu = (item) => {
      data.showVideoDialog = true;
      data.videoTitle = item.name;
      closeMenu();
    };
    //关闭
    const change = () => {
      clearTimeout(data.time);
      data.time = setTimeout(() => {
        data.showMenu = !data.showMenu;
        // setZIndex(cameraRef);
      }, 100);
    };
    //关闭
    const close = () => {
      data.time = setTimeout(() => {
        data.showMenu = false;
        // setZIndex(cameraRef);
      }, 100);
    };
    // 关闭菜单
    const closeMenu = () => {
      data.showMenu = false;
    };

    return { ...refData, clickMenu, change, close };
  },
});
</script>
<style  lang='scss' scoped >
.mapVideo {
  width: 500px;
  height: 300px;

  .pointMenuList {
    position: absolute;
    &.hideShow .pointMenuItem {
      pointer-events: none;
      transform: translate(0, 0) scale(0) rotate(720deg) !important;
    }
    .pointMenuItem {
      width: 50px;
      height: 50px;
      color: #fff;
      $bg: rgba(
        $color: #122a42,
        $alpha: 0.8,
      );
      @include border-gradient($bg, top, #0064e6, #52f9ff);
      text-align: center;
      border-radius: 50%;
      font-size: 14px;
      letter-spacing: 2px;
      position: absolute;
      left: -25px;
      top: -25px;
      z-index: 1;
      cursor: pointer;
      @include flex-row-c-c;
      transition: all 0.3s;
    }
  }
}
</style>